function getDraftFullData(state) {
  return {
    draftFull: state.draftFull.draftFull,
    convertingToFull: state.draftFull.convertingToFull,
    convertingToFullSuccess: state.draftFull.convertingToFullSuccess,
    convertingToFullError: state.draftFull.convertingToFullError
  };
}

export { getDraftFullData };
